// removed by extract-text-webpack-plugin
module.exports = {"cyberMonday":"qempo_CyberMondayBanner_cyberMonday-1Fl2Ppv","content":"qempo_CyberMondayBanner_content-38eMSyn","text":"qempo_CyberMondayBanner_text-3brLVTj","timeWrap":"qempo_CyberMondayBanner_timeWrap-27jc31B","unitWrap":"qempo_CyberMondayBanner_unitWrap-19R23IK","fromMobile":"qempo_CyberMondayBanner_fromMobile-1avU4al","number":"qempo_CyberMondayBanner_number-1iDk7_Z"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/home/components/CyberMondayBanner/CyberMondayBanner.scss
// module id = 1458
// module chunks = 0